import { createContext, useContext, type MutableRefObject } from 'react';

interface MenuContextValue {
  activeMenuItemId: string | null;
  setActiveMenuItemId: (id: string | null) => void;
  menuButtonsRef: MutableRefObject<Set<HTMLElement>> | null;
  dropdownContentsRef: MutableRefObject<Set<HTMLElement>> | null;
}

export const MenuContext = createContext<MenuContextValue | undefined>(undefined);

export const useMenuContext = () => {
  const context = useContext(MenuContext);
  if (!context) {
    throw new Error(
      'useMenuContext must be used within a MenuContext.Provider. Make sure the component is wrapped with <MenuContext.Provider>.'
    );
  }
  return context;
};
